var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-select',{attrs:{"multiple":true,"color":"#c42111","items":_vm.items,"rules":[_vm.validation.min(_vm.selected, _vm.minSelected)]},on:{"change":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }